import { Termin } from '@/domain/termine/shared/types/Termin';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { TerminPopoverContent } from './TerminPopoverContent';
import { usePopoverDirection } from '@/domain/termine/shared/utils/getPopoverDirection';
import { TerminDeleteDialog } from './TerminDeleteDialog';
import { useState } from 'react';

export function TerminPopover({
  termin,
  children,
}: {
  termin: Termin;
  children: React.ReactNode;
}) {
  const popoverDirection = usePopoverDirection();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  return (
    <Popover modal>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        side={popoverDirection}
        align="center"
        className="p-0 bg-transparent shadow-none border-none text-left"
        tabIndex={-1}
        onOpenAutoFocus={(e) => {
          e.preventDefault();
        }}
        onInteractOutside={(e) => {
          e.stopPropagation();
        }}>
        <TerminPopoverContent
          termin={termin}
          onDeleteClick={() => setDeleteDialogOpen(true)}
        />
      </PopoverContent>
      <TerminDeleteDialog
        termin={termin}
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
      />
    </Popover>
  );
}
